import React from "react";
import { Card, CardBody, CardHeader, Col, Spinner } from "reactstrap";
import * as moment from "moment";

import { ActivityReportData } from "./types";
import { cleanName } from "./format";

/** The people driving the traffic in the selected window. */
const MostActiveUsers = ({
  data,
  loading,
}: {
  data: ActivityReportData | null;
  loading: boolean;
}) => {
  const rows = data?.users || [];

  return (
    <Col xxl={6}>
      <Card className="card-height-100">
        <CardHeader className="align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1">Most active users</h4>
        </CardHeader>
        <CardBody>
          {loading ? (
            <div className="text-center py-5">
              <Spinner color="primary" size="sm" />
            </div>
          ) : rows.length === 0 ? (
            <div className="text-center text-ink-muted py-5">
              No user activity in this period.
            </div>
          ) : (
            <div className="table-responsive table-card">
              <table className="table align-middle table-borderless table-nowrap mb-0">
                <thead className="text-ink-muted table-light">
                  <tr>
                    <th scope="col">User</th>
                    <th scope="col">Visits</th>
                    <th scope="col">Pages visited</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row) => (
                    <tr key={row.userId}>
                      <td>
                        <div
                          className="fw-medium text-truncate"
                          title={cleanName(row.name)}
                        >
                          {cleanName(row.name)}
                        </div>
                        <small className="text-ink-muted text-truncate d-block">
                          {row.agencyName || row.email || ""}
                          {row.lastActiveAt
                            ? ` · last active ${moment(
                                new Date(row.lastActiveAt)
                              ).fromNow()}`
                            : ""}
                        </small>
                      </td>
                      <td>{row.visits}</td>
                      <td>{row.pagesVisited}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </CardBody>
      </Card>
    </Col>
  );
};

export default MostActiveUsers;
